export const HOST_API_KEY = 'https://api.inua.com.ua'
